import { useTranslation } from "react-i18next";
import "./outage-banner.less";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faOctagonExclamation } from "@awesome.me/kit-b311a11e92/icons/classic/solid";

function OutageBanner() {
  const { t } = useTranslation();

  return (
    <section className="outage-banner" role="alert" aria-live="assertive">
      <div className="outage-banner-wrapper">
        <FontAwesomeIcon icon={faOctagonExclamation} className="outage-banner-icon" aria-hidden="true" focusable={false} />
      </div>
      <div className="outage-banner-wrapper">
        <div className="outage-banner-header">
          <h3 className="outage-banner-title">{t("MAIN_OUTAGE_TITLE")}</h3>
        </div>
        <p className="outage-banner-message">{t("MAIN_OUTAGE_MESSAGE")}</p>
        <p className="outage-banner-message">
          {t("MAIN_OUTAGE_CONTACT_SUPPORT")}
        </p>
        <div className="outage-banner-contact">
          <div className="outage-banner-contact-row">
            <p className="outage-banner-contact-label">
              {t("MAIN_OUTAGE_US_LABEL")}
            </p>
            <div className="outage-banner-contact-detail">
              <p>{t("MAIN_OUTAGE_US_DESCRIPTION")}</p>
              <p className="outage-banner-contact-note">
                {t("MAIN_OUTAGE_US_NOTE")}
              </p>
            </div>
          </div>
          <div className="outage-banner-contact-row">
            <p className="outage-banner-contact-label">
              {t("MAIN_OUTAGE_JAPAN_LABEL")}
            </p>
            <div className="outage-banner-contact-detail">
              <p>{t("MAIN_OUTAGE_JAPAN_DESCRIPTION")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OutageBanner;
